import { NavLink } from "react-router-dom";

import { Tooltip, UnstyledButton } from "@mantine/core";

import { NavBarLink } from "../types/navbar";

interface NavBarButtonProps {
  link: NavBarLink;
  children: React.ReactNode;
  collapsed?: boolean;
}

export default function NavBarButton({ link, children, collapsed }: NavBarButtonProps) {
  const style = {
    textDecoration: "none",
    color: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  } as const;

  const tooltipProps = {
    label: link.label,
    position: "right",
    offset: 8,
    withArrow: true,
    hidden: !collapsed,
  } as const;

  switch (link.type) {
    case "anchor":
      return (
        <Tooltip {...tooltipProps}>
          <NavLink to={link.to} style={style}>
            {children}
          </NavLink>
        </Tooltip>
      );
    case "button":
      return (
        <Tooltip {...tooltipProps}>
          <UnstyledButton style={style} onClick={link.onClick}>
            {children}
          </UnstyledButton>
        </Tooltip>
      );
    default:
      return null;
  }
}
